<script lang="ts">
  import { between } from 'polished'

  export let cssCalc = between('9.2rem', '12.8rem', '32rem', '72rem')
</script>

<h1 data-text="Brian Hough" style="--interpolation:{cssCalc}"><slot /></h1>

<style>
  @keyframes glitch-anim-1 {
    0% {
      clip-path: none;
    }
    82% {
      clip-path: none;
    }
    83% {
      clip-path: inset(40% 0 61% 0);
    }
    86% {
      clip-path: inset(92% 0 1% 0);
    }
    90% {
      clip-path: inset(43% 0 1% 0);
    }
    93% {
      clip-path: inset(25% 0 58% 0);
    }
    96% {
      clip-path: inset(54% 0 7% 0);
    }
    100% {
      clip-path: inset(58% 0 43% 0);
    }
  }
  @keyframes glitch-anim-2 {
    0% {
      clip-path: none;
    }
    82% {
      clip-path: none;
    }
    83% {
      clip-path: inset(20% 0 12% 0);
    }
    86% {
      clip-path: inset(87% 0 45% 0);
    }
    90% {
      clip-path: inset(43% 0 9% 0);
    }
    93% {
      clip-path: inset(35% 0 98% 0);
    }
    96% {
      clip-path: inset(7% 0 54% 0);
    }
    100% {
      clip-path: inset(43% 0 12% 0);
    }
  }
  h1 {
    position: relative;
    margin-top: 5rem;
    margin-bottom: 2.5rem;
    font-family: var(--headline-font);
    font-size: clamp(9.2rem, var(--interpolation), 12.8rem);
    font-weight: 500;
    line-height: 1;
    text-align: center;
    text-transform: uppercase;
    color: var(--color-callout);
  }
  h1::before,
  h1::after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 0.2rem);
    background: var(--color-background);
  }
  h1::after {
    text-shadow: -0.1rem 0 var(--secondary-color);
    animation: glitch-anim-1 10s infinite linear alternate-reverse;
  }
  h1::before {
    text-shadow: -0.2rem 0 var(--primary-callout);
    animation: glitch-anim-2 11s infinite linear alternate-reverse;
  }
</style>
